'use client';

import { classNames } from '@schuelerhilfe/shared/src/utils/classNames';
import { CAMPAIGN_VARIANT_TOP_SPACING_IN_FLOW_ONLY } from '../campaignSpacing';
import { TickerComponent } from './TickerComponent';

/**
 * Campaign variant B. Was a bare re-export of {@link TickerComponent} until
 * SH-415 — it had to become a real wrapper to carry the variant's top margin,
 * since a class added to the shared component would have landed on variant A
 * as well.
 */
export function TickerComponentB(
  props: React.ComponentProps<typeof TickerComponent>,
) {
  return (
    <TickerComponent
      {...props}
      className={classNames(
        props.className,
        CAMPAIGN_VARIANT_TOP_SPACING_IN_FLOW_ONLY,
      )}
    />
  );
}
